import { createRouter, createWebHistory } from "vue-router";
import store from "../store";

const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/auth/LoginView.vue"),
  },
  {
    path: "/",
    component: () => import("../layouts/SidebarLayout.vue"),
    meta: { requiresAuth: true },
    children: [
      {
        path: "",
        redirect: "/dashboard",
      },
      {
        path: "dashboard",
        name: "dashboard",
        component: () => import("../views/dashboard/MainStatsView.vue"),
      },
      {
        path: "recovery",
        name: "recovery-search",
        component: () => import("../views/recovery/RecoverySearchView.vue"),
      },
      {
        path: "recovery/history",
        name: "recovery-history",
        component: () => import("../views/recovery/RecoveryHistoryView.vue"),
      },
      // Placeholder for future extensibility
      {
        path: "users",
        name: "users",
        component: () => import("../views/HomeView.vue"), // Reuse Home for now
      },
      {
        path: "settings",
        name: "settings",
        component: () => import("../views/AboutView.vue"), // Reuse About for now
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to: any, from: any, next: any) => {
  const isAuthenticated = store.getters["auth/isAuthenticated"];
  if (to.meta.requiresAuth && !isAuthenticated) {
    next("/login");
  } else if (to.name === "login" && isAuthenticated) {
    next("/dashboard");
  } else {
    next();
  }
});

export default router;
